import { app } from "../../../service/serviceLMS";
import React, { useState } from "react";
import {  Button, message,} from "antd";
import {
  MoreOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import QuizModal from "./QuizModal";
import CourseReportOptionsModal from "../../admin/booksAdmin/CourseReportOptionsModal";
import PDFReaderModal from "../../admin/booksAdmin/PDFReaderModal";
import {
  previewCourseReportPdf,
  downloadCourseReportPdf,
  downloadCourseReportExcel,
} from "../../../service/AdminService/BookService";
import CommonTable from "../../shared/table/Table";
import LottieIcon from "../lottieIcon/LottieIcon";
import CustomPopover from "../custompopover/CustomPopover";
import viewIcon from "../../../assets/icons/Eye.svg";
import editIcon from "../../../assets/icons/Edit.svg";
import deleteIcon from "../../../assets/icons/Delete.svg";
const CourseTable = ({
  onEditClick,
  onDeleteClick,
  entries,
  totalElements,
  currentPage,
  setTotalElements,
  pageSize,
  onTableChange,
}) => {
  const navigate = useNavigate();
  const [quizModalOpen, setQuizModalOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [quizToEdit, setQuizToEdit] = useState(null);
  const [isMetadataOnly, setIsMetadataOnly] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [reportBlobUrl, setReportBlobUrl] = useState("");
  const [reportingCourseId, setReportingCourseId] = useState(null);
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [reportOptions, setReportOptions] = useState(null);
  const [visiblePopover, setVisiblePopover] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);

  const handleReportOptionsSubmit = async (options) => {
    try {
      setShowOptionsModal(false);
      setReportOptions(options);

      const blob = await previewCourseReportPdf(options);
      const blobUrl = URL.createObjectURL(blob);
      setReportBlobUrl(blobUrl);
      setIsReportModalOpen(true);
    } catch (err) {
      message.error("Failed to generate report");
    }
  };

  const handleDownloadPdf = async () => {
    try {
      await downloadCourseReportPdf(reportOptions);
      message.success("PDF downloaded successfully");
    } catch {
      message.error("Failed to download PDF");
    }
  };

  const handleDownloadExcel = async () => {
    try {
      await downloadCourseReportExcel(reportOptions);
      message.success("Excel downloaded successfully");
    } catch {
      message.error("Failed to download Excel");
    }
  };

  const handleQuizSubmit = async (quizMetadata) => {
    try {
      const payload = {
        ...quizMetadata,
        parentId: selectedCourse.courseId,
        createdBy: 1,
        parentType: "course",
      };
      const response = await app.post("course/api/client-api/quizzes", payload);
      const result = response?.data?.data;
      const messageText = response?.data?.message;

      if (result?.quizId) {
        message.success(messageText || "Quiz created successfully.");
        setQuizModalOpen(false);
        navigate(
          `/course-content/${selectedCourse.courseId}/quizzes/${result.quizId}/questions`
        );
      } else {
        throw new Error("Invalid response format");
      }
    } catch (err) {
      console.error("Quiz creation failed", err);
      message.error("Failed to create quiz");
    }
  };

  const columns = [
    {
      title: (
        <div style={{ paddingLeft: 36, textAlign: "left" }}>Course Id</div>
      ),
      width:150,
      dataIndex: "courseId",
      onCell: () => ({
        style: {
          textAlign: "left",
          paddingLeft: "48px",
        },
      }),
      align: "left",
    },
    { title: "Title", dataIndex: "title", width:250},
    { title: "Description", dataIndex: "description", width:300 },
    { title: "Level", dataIndex: "level", width:150 },
    { title: "Owner ID", dataIndex: "ownerId", width:150 },
    {
      title: "Is Active",
      dataIndex: "isActive",
      render: (active) => (active ? "Yes" : "No"),
      width:150
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (createdAt) =>
        createdAt
          ? new Date(createdAt.split(".")[0]).toLocaleDateString()
          : "N/A",
      width:150
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      render: (updatedAt) => new Date(updatedAt).toLocaleDateString(),
      width:150
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      align: "center",
      render: (_, record) => {
        const popoverContent = (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <Button
              onClick={() => {
                navigate(`/course-content/${record.courseId}`);
                setVisiblePopover(null);
              }}
              style={{ width: "11rem" }}
              className="navbar-item"
              onMouseEnter={() => setHoveredButton("view")}
              onMouseLeave={() => setHoveredButton(null)}
            >
              <span>View Course</span>
              {hoveredButton === "view" ? (
                <LottieIcon name="viewIcon" size={28} shouldPlay={true} />
              ) : (
                <img src={viewIcon} alt="view-icon" height={28} />
              )}
            </Button>

            <Button
              onClick={() => {
                onEditClick(record);
                setVisiblePopover(null);
              }}
              style={{ width: "11rem" }}
              className="navbar-item"
              onMouseEnter={() => setHoveredButton("edit")}
              onMouseLeave={() => setHoveredButton(null)}
            >
              <span>Edit</span>
              {hoveredButton === "edit" ? (
                <LottieIcon name="editIcon" size={24} shouldPlay={true} />
              ) : (
                <img src={editIcon} alt="edit-icon" height={28} />
              )}
            </Button>

            <Button
              onClick={() => {
                navigate(`/course-report/${record.courseId}`);
                setVisiblePopover(null);
              }}
              style={{ width: "11rem" }}
              className="navbar-item"
              onMouseEnter={() => setHoveredButton("report")}
              onMouseLeave={() => setHoveredButton(null)}
            >
              <span>Report</span>
              {hoveredButton === "report" ? (
                <LottieIcon name="viewIcon" size={24} shouldPlay={true} />
              ) : (
                <img src={viewIcon} alt="report-icon" height={28} />
              )}
            </Button>

            <Button
              onClick={() => {
                navigate(`/course-content/${record.courseId}/quizzes`);
                setVisiblePopover(null);
              }}
              style={{ width: "11rem" }}
              className="navbar-item"
              onMouseEnter={() => setHoveredButton("quiz")}
              onMouseLeave={() => setHoveredButton(null)}
            >
              <span>{record.quizAvailable ? "Manage Quiz" : "Add Quiz"}</span>
              {hoveredButton === "quiz" ? (
                <LottieIcon name="viewIcon" size={24} shouldPlay={true} />
              ) : (
                <img src={viewIcon} alt="quiz-icon" height={28} />
              )}
            </Button>

            <Button
              onClick={() => {
                setVisiblePopover(null);
                onDeleteClick(record);
              }}
              style={{ width: "11rem" }}
              className="navbar-item"
              onMouseEnter={() => setHoveredButton("delete")}
              onMouseLeave={() => setHoveredButton(null)}
            >
              <span>Delete</span>
              {hoveredButton === "delete" ? (
                <LottieIcon name="trashIcon" size={24} shouldPlay={true} />
              ) : (
                <img src={deleteIcon} alt="delete-icon" height={28} />
              )}
            </Button>
          </div>
        );

        return (
          <CustomPopover
            content={popoverContent}
            trigger="click"
            className="admin-popover"
            placement="bottomRight"
            visible={visiblePopover === record.courseId}
            onVisibleChange={(visible) => {
              setVisiblePopover(visible ? record.courseId : null);
              if (!visible) setHoveredButton(null);
            }}
            getPopupContainer={() => document.body}
          >
            <MoreOutlined
              style={{ fontSize: "16px", color: "black", cursor: "pointer" }}
            />
          </CustomPopover>
        );
      },
    },
  ];

  return (
    <div>
      <CommonTable
        data={entries}
        columns={columns}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalElements,
          showSizeChanger: true,
        }}
        onChange={onTableChange}
        serverSide={true}
      />

      <PDFReaderModal
        isOpen={isReportModalOpen}
        pdfUrl={reportBlobUrl}
        onClose={() => {
          setIsReportModalOpen(false);
          URL.revokeObjectURL(reportBlobUrl);
          setSelectedCourse(null);
        }}
        blockTime={0}
        showDownload={true}
        onDownloadPdf={handleDownloadPdf}
        onDownloadExcel={handleDownloadExcel}
      />

      {showOptionsModal && (
        <CourseReportOptionsModal
          isOpen={showOptionsModal}
          onClose={() => setShowOptionsModal(false)}
          onSubmit={handleReportOptionsSubmit}
          courseId={String(reportingCourseId)}
        />
      )}

      {selectedCourse && (
        <QuizModal
          open={quizModalOpen}
          onClose={() => setQuizModalOpen(false)}
          onSubmit={handleQuizSubmit}
          course={selectedCourse}
          metadataOnly={isMetadataOnly}
          initialValues={quizToEdit}
        />
      )}
    </div>
  );
};

export default CourseTable;
